// Only show Klaviyo Teaser on scroll

// console.log("Loaded")

const observer = new MutationObserver(() => {
  const teaser = document.querySelector('[class*="kl-teaser-"]');
  if (teaser) {
    teaser.style.opacity = 0; // hide initially
    teaser.style.pointerEvents = "none"
    window.addEventListener("scroll", () => {
      if (window.scrollY > 300) {
        teaser.style.opacity = 1;
        teaser.style.pointerEvents = "auto"
      }
    });
    observer.disconnect();
  }
});

observer.observe(document.body, { childList: true, subtree: true });